export const Branding = () => {
  return (
    <>
      <div className="branding flex content-center mt-5 ">
        <img className=" h-28" src="/ongaku/logo.png" alt="" />
        <p className="text-4xl font-sans my-auto text-white">ongaku</p>
      </div>
    </>
  );
};
